import styled from "styled-components";
import { BREACKPOINT, COLORS } from "utils/constants";

type CardProps = {
  isSelected?: boolean;
  isSelectable?: boolean;
};

export const Card = styled.div<CardProps>`
  display: flex;
  align-items: center;
  padding: 20px;
  border: 2px solid
    ${props => (props.isSelected ? "transparent" : COLORS.GREY_BORDER)};
  outline: ${props => (props.isSelected ? "1px solid #4AA564" : "none")};
  outline-offset: -0.5px;
  border-radius: 6px;
  margin-bottom: 16px;
  cursor: ${props => (props.isSelectable ? "pointer" : "default")};
  background-color: ${props => (props.isSelected ? "#F6FFF9" : COLORS.WHITE)};
  transition: border-color 0.2s ease;

  &:hover {
    border-color: ${props =>
      props.isSelectable ? COLORS.ORANGE_INDICATOR : COLORS.GREY_BORDER};
  }

  @media (${BREACKPOINT.DOWN_420}) {
    padding: 16px;
  }
`;

export const RadioCircle = styled.div<{ isSelected?: boolean }>`
  width: 22px;
  height: 22px;
  min-width: 22px;
  border-radius: 50%;
  border: 2px solid
    ${props =>
      props.isSelected ? COLORS.ORANGE_INDICATOR : COLORS.GREY_BORDER};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;

  &::after {
    content: "";
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: ${props =>
      props.isSelected ? COLORS.ORANGE_INDICATOR : "transparent"};
  }
`;

export const Info = styled.div`
  flex: 1;
`;

export const MemberName = styled.p`
  font-size: 16px;
  font-family: "OpenSans-SemiBold";
  margin: 0 0 10px 0;
  color: #243e5e;
`;

export const DetailRow = styled.p`
  font-size: 14px;
  margin: 0 0 2px 0;
  color: #243e5e;
`;

export const MemberIdLabel = styled.span`
  color: #243e5e;
  font-size: 14px;
  font-family: "OpenSans-Regular", "Open Sans", sans-serif;
  font-weight: 600;
  word-wrap: break-word;
`;

export const ConnectedApps = styled.p`
  font-size: 13px;
  margin: 6px 0 0 0;
  color: #243e5e;
`;

export const ConnectedAppsValue = styled.span`
  color: #243e5e;
  font-size: 14px;
  font-family: "OpenSans-Regular", "Open Sans", sans-serif;
  font-weight: 400;
  word-wrap: break-word;
`;

export const ConnectedAppsLabel = styled.span`
  color: #243e5e;
  font-size: 14px;
  font-family: "OpenSans-Regular", "Open Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  word-wrap: break-word;
`;

export const NoneText = styled.p`
  color: #243e5e;
  font-size: 14px;
  font-family: "OpenSans-Regular", "Open Sans", sans-serif;
  font-style: italic;
  font-weight: 400;
  word-wrap: break-word;
  margin: 6px 0 0 0;
`;
